export default [
  {
    title: "Dashboard",
    key: "dashboard",
    url: "/dashboard",
    icon: "icmn icmn-stack"
  },
  {
    title: "Empty Page",
    key: "empty",
    url: "/empty",
    icon: "icmn icmn-books"
  }
];



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuTop/menuData.js